import { useContext } from 'react';
import { ContentfulContext } from '../ContentfulProvider';
/** @public */
function useContentful(fieldName, activePromotionKeys) {
    var _a;
    var contentful = useContext(ContentfulContext);
    if (!fieldName) {
        return contentful;
    }
    var field = (_a = contentful === null || contentful === void 0 ? void 0 : contentful.fields) === null || _a === void 0 ? void 0 : _a[fieldName];
    var promoVariantsField = field;
    if (promoVariantsField === null || promoVariantsField === void 0 ? void 0 : promoVariantsField.promotionKey) {
        return (activePromotionKeys === null || activePromotionKeys === void 0 ? void 0 : activePromotionKeys.includes(promoVariantsField.promotionKey))
            ? promoVariantsField.promotionContent
            : promoVariantsField.defaultContent;
    }
    return field;
}
export default useContentful;
//# sourceMappingURL=useContentful.js.map